// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `pre code.hljs {
  display: block;
  overflow-x: auto;
  padding: 1em
}
code.hljs {
  padding: 3px 5px
}
/*

Monokai Sublime style. Derived from Monokai by noformnocontent http://nn.mit-license.org/

*/
.hljs {
  background: #23241f;
  color: #f8f8f2
}
.hljs-tag,
.hljs-subst {
  color: #f8f8f2
}
.hljs-strong,
.hljs-emphasis {
  color: #a8a8a2
}
.hljs-bullet,
.hljs-quote,
.hljs-number,
.hljs-regexp,
.hljs-literal,
.hljs-link {
  color: #ae81ff
}
.hljs-code,
.hljs-title,
.hljs-section,
.hljs-selector-class {
  color: #a6e22e
}
.hljs-strong {
  font-weight: bold
}
.hljs-emphasis {
  font-style: italic
}
.hljs-keyword,
.hljs-selector-tag,
.hljs-name,
.hljs-attr {
  color: #f92672
}
.hljs-symbol,
.hljs-attribute {
  color: #66d9ef
}
.hljs-params,
.hljs-title.class_,
.hljs-class .hljs-title {
  color: #f8f8f2
}
.hljs-string,
.hljs-type,
.hljs-built_in,
.hljs-selector-id,
.hljs-selector-attr,
.hljs-selector-pseudo,
.hljs-addition,
.hljs-variable,
.hljs-template-variable {
  color: #e6db74
}
.hljs-comment,
.hljs-deletion,
.hljs-meta {
  color: #75715e
}`, "",{"version":3,"sources":["webpack://./node_modules/highlight.js/styles/monokai-sublime.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB;AACF;AACA;EACE;AACF;AACA;;;;CAIC;AACD;EACE,mBAAmB;EACnB;AACF;AACA;;EAEE;AACF;AACA;;EAEE;AACF;AACA;;;;;;EAME;AACF;AACA;;;;EAIE;AACF;AACA;EACE;AACF;AACA;EACE;AACF;AACA;;;;EAIE;AACF;AACA;;EAEE;AACF;AACA;;;EAGE;AACF;AACA;;;;;;;;;EASE;AACF;AACA;;;EAGE;AACF","sourcesContent":["pre code.hljs {\n  display: block;\n  overflow-x: auto;\n  padding: 1em\n}\ncode.hljs {\n  padding: 3px 5px\n}\n/*\n\nMonokai Sublime style. Derived from Monokai by noformnocontent http://nn.mit-license.org/\n\n*/\n.hljs {\n  background: #23241f;\n  color: #f8f8f2\n}\n.hljs-tag,\n.hljs-subst {\n  color: #f8f8f2\n}\n.hljs-strong,\n.hljs-emphasis {\n  color: #a8a8a2\n}\n.hljs-bullet,\n.hljs-quote,\n.hljs-number,\n.hljs-regexp,\n.hljs-literal,\n.hljs-link {\n  color: #ae81ff\n}\n.hljs-code,\n.hljs-title,\n.hljs-section,\n.hljs-selector-class {\n  color: #a6e22e\n}\n.hljs-strong {\n  font-weight: bold\n}\n.hljs-emphasis {\n  font-style: italic\n}\n.hljs-keyword,\n.hljs-selector-tag,\n.hljs-name,\n.hljs-attr {\n  color: #f92672\n}\n.hljs-symbol,\n.hljs-attribute {\n  color: #66d9ef\n}\n.hljs-params,\n.hljs-title.class_,\n.hljs-class .hljs-title {\n  color: #f8f8f2\n}\n.hljs-string,\n.hljs-type,\n.hljs-built_in,\n.hljs-selector-id,\n.hljs-selector-attr,\n.hljs-selector-pseudo,\n.hljs-addition,\n.hljs-variable,\n.hljs-template-variable {\n  color: #e6db74\n}\n.hljs-comment,\n.hljs-deletion,\n.hljs-meta {\n  color: #75715e\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
